import type { ReactNode } from 'react'
import ShopChromeLayout from '../../src/ssr/layout/ShopChromeLayout'

export default function ProductsLayout({ children }: { children: ReactNode }) {
  return <ShopChromeLayout>{children}</ShopChromeLayout>
}
